import Promise from 'promise';
import { axios } from '../_helpers';

export const BookCodeService = {
    getAllBookCodes,
    addBookcode,
    updateBookcode,
    deleteBookcodes,
    exportCourseSetting,
    updateBookCodeActiveStatus,
    CheckBookCodeHasVideo,
    getConfigValue
}

function getAllBookCodes() {
    return new Promise(function (resolve, reject) {
        axios.post('getAllBookcode').then((res) => {
            if (res.isSuccess) {
                resolve(res.data);
            } else {
                reject(res.message);
            }
        }).catch(error => { 
            reject(error.message);
        });
    });
};

function addBookcode(params) {
    return new Promise(function (resolve, reject) {
        axios.post('addBookcode', params).then((res) => {
            resolve(res);
        }).catch(error => { 
            reject(error.message);
        });
    });
};

function updateBookcode(params) {
    return new Promise(function (resolve, reject) {
        axios.post('updateBookcode', params).then((res) => {
            resolve(res);
        }).catch(error => { 
            reject(error.message);
        });
    });
};

function deleteBookcodes(params) {
    return new Promise(function (resolve, reject) {
        axios.post('deleteBookcode', params).then((res) => {
            resolve(res);
        }).catch(error => { 
            reject(error.message);
        });
    });
};

function exportCourseSetting(bookId) {
    return new Promise(function (resolve, reject) {
        axios.get('exportCourseSetting?bookId='+ bookId).then((res) => {
            resolve(res);
        }).catch(error => { 
            reject(error.message);
        });
    });
};

function updateBookCodeActiveStatus(params) {
    return new Promise(function (resolve, reject) {
        axios.post('updateBookCodeActiveStatus', params).then((res) => {
            resolve(res);
        }).catch(error => { 
            reject(error.message);
        });
    });
};

function CheckBookCodeHasVideo(params) {
    return new Promise(function (resolve, reject) {
        axios.post('CheckBookCodeHasVideo', params).then((res) => {
            resolve(res);
        }).catch(error => { 
            reject(error.message);
        });
    });
};

function getConfigValue(configKey) {
    return new Promise(function (resolve, reject) {
        axios.post('getConfigValue', {configKey}).then((res) => {
            resolve(res);
        }).catch(error => { 
            reject(error.message);
        });
    });
};


// WEBPACK FOOTER //
// ./src/_services/book-code.service.js